<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.155 10.4883L12.6433 19.9999L22.155 29.5116L24.5117 27.1549L17.3567 19.9999L24.5117 12.8449L22.155 10.4883Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#fff',
    },
  },
}
</script>
